"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _packet = require("./packet");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// The program association table lists all programs available in the transport stream.
// Each of the listed programs is identified by a 16-bit value called program_number.
// Each of the programs listed in PAT has an associated value of PID for its program map table (PMT).
// The value 0x0000 for program_number is reserved to specify the PID where to look for network information table. If such a program is not present in PAT the default PID value (0x0010) shall be used for NIT.
// TS packets containing PAT information always have PID 0x0000.
var PAT =
/*#__PURE__*/
function (_Packet) {
  _inherits(PAT, _Packet);

  function PAT(header, bitReader) {
    var _this;

    _classCallCheck(this, PAT);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PAT).call(this, header, bitReader));
    _this.objType = 'PAT';
    _this.ptrField = bitReader.readBits(8);

    if (_this.ptrField) {
      bitReader.readBits(_this.ptrField * 8);
    }

    _this.tableID = bitReader.readBits(8);
    _this.sectionSyntaxIndicator = bitReader.readBit();
    _this.privateBit = bitReader.readBit();
    bitReader.readBits(2); // reserved bits

    bitReader.readBits(2); // section length unused bits

    _this.sectionLength = bitReader.readBits(10);
    _this.programs = [];
    var tableID = bitReader.readBits(16);
    bitReader.readBits(2); // reserved

    var versionNumber = bitReader.readBits(5);
    var currentNextIndicator = bitReader.readBit();
    var sectionNumber = bitReader.readBits(8);
    var lastSectionNumber = bitReader.readBits(8);
    var programNumber = bitReader.readBits(16);
    bitReader.readBits(3);
    var programMapPID = bitReader.readBits(13);

    _this.programs.push({
      programNumber: programNumber,
      mapID: programMapPID
    });

    _this.crc = bitReader.readBits(32);
    return _this;
  }

  _createClass(PAT, [{
    key: "pmtID",
    get: function get() {
      return this.programs[0].mapID;
    }
  }]);

  return PAT;
}(_packet.Packet);

var _default = PAT;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/ts/pat.js
// module id = 474
// module chunks = 0